import { render, staticRenderFns } from "./TicketBatchFormHeader.vue?vue&type=template&id=79e853d6"
import script from "./TicketBatchFormHeader.vue?vue&type=script&lang=js"
export * from "./TicketBatchFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports